import * as React from "react";
import Render from "source/app/presentation/Shared/Render";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { IDeepWorkKipsRecord } from "../DeepWorkKipsChart";
import * as styles from "../DeepWorkKipsChart.css";
import { DisplayEmotionCharacterCounts } from "./DisplayEmotionCharacterCounts/DisplayEmotionCharacterCounts";
import { DisplayMonumentalIcons } from "./DisplayMonumentalIcons/DisplayMonumentalIcons";

export function DisplayDWKCRecord({
    row,
    index,
}: {
    row: IDeepWorkKipsRecord;
    index: number;
}) {
    return (
        <Render id={`DeepWorkDataRow_${index}`} when={ShouldDisplayRow(index)}>
            <div>
                <span>
                    <span style={{ paddingRight: `10px` }}>{row.date}</span>
                    <strong>{row.value}</strong>
                    <DisplayNumLogEntries numLogEntries={row.numLogEntries} />
                    <span
                        className={styles.stars}
                        style={{
                            textShadow: `0px 0px ${
                                Math.floor(row.value / 100) * 2
                            }px gold`,
                        }}
                    >
                        <DisplayStars kips={row.value} />
                    </span>
                    <DisplayMonumentalIcons mmRecords={row.monumentalRecords} />
                    <DisplayEmotionCharacterCounts
                        characterCounts={row.relevantCharacterCounts}
                    />
                </span>
            </div>
        </Render>
    );
}

function DisplayStars({ kips }: { kips: number }) {
    const numStars = Math.floor(kips / 100);

    const starColor = starColors.find((sc) => sc.count === numStars);
    const color = starColor ? starColor.color : `silver`;

    return (
        <span
            id="displayStars"
            className={StyleClass(`dwkc_stars_${numStars}`, {
                color,
            })}
        >
            {"★".repeat(numStars)}
        </span>
    );
}

const starColors = [
    { count: 0, color: "#ff5555" },
    { count: 1, color: "#FFA500" },
    { count: 2, color: "#FFFF00" },
    { count: 3, color: "#baf14a" },
    { count: 4, color: "#6fffff" },
    { count: 5, color: "#b99cff" },
];

function ShouldDisplayRow(index: number) {
    const allExceptFirstRow = index > 0;
    return allExceptFirstRow;
}

function DisplayNumLogEntries({ numLogEntries }: { numLogEntries: number }) {
    const styleClass = StyleClass(`numLogEntriesText`, {
        opacity: 0.7,
        marginLeft: `10px`
    });

    return (
        <span className={styleClass} data-tip={`${numLogEntries} log entries`}>
            {numLogEntries}
        </span>
    );
}
